import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  ChevronDown,
  ChevronUp,
  LogOut,
  LucideAngularModule,
  Search,
  User,
} from 'lucide-angular';
import { AuthService } from '@app/auth/auth.service';
import { UserModel } from '@app/users/shared/user.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [LucideAngularModule, FormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  standalone: true,
})
export class HeaderComponent implements OnInit {
  protected readonly User = User;
  protected readonly LogOutIcon = LogOut;
  protected readonly ChevronUpIcon = ChevronUp;
  protected readonly ChevronDownIcon = ChevronDown;
  protected readonly SearchIcon = Search;

  protected dropdownOpen = false;
  protected user?: UserModel | null = null;
  protected searchQuery = '';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.getUser().subscribe({
      next: (user) => {
        this.user = user;
      },
      error: () => {
        this.user = null;
      },
    });
  }

  logout() {
    this.authService.logout();
  }

  onSearch() {
    if (this.searchQuery.trim()) {
      // TODO: Implement global search functionality
      console.log('Searching for:', this.searchQuery);
    }
  }

  onSearchKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  protected readonly environment = environment;
}
